import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

import ScrollToTop from './components/ScrollToTop';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);